import React, { memo, useMemo } from 'react';
import { Button, SageTokens } from '@kajabi/sage-react';

import CopyMagic from 'common/components/CopyMagic';

import { ProductEvents } from 'common/components/CopyMagic/CopyMagic.types';
import { HeadlineAssistantResultType } from 'common/components/CopyMagic/generators/HeadlineAssistant/HeadlineAssistant.types';
import './style.scss';

type Props = {
  productArea: string;
  prefix?: string;
  // eslint-disable-next-line no-unused-vars
  onApply: (result: HeadlineAssistantResultType) => void;
};

const copyMagicButton = (
  <Button color={Button.COLORS.ACCENT} fullWidth icon={SageTokens.ICONS.AI_WRITER_FILLED}>
    Generate content for your page
  </Button>
);

const HeadlineAssistantButton = ({ productArea, prefix, onApply }: Props) => {
  const productEvents: ProductEvents = useMemo(
    () => ({
      prefix,
      payload: {
        'Product Area': productArea,
      },
    }),
    [productArea, prefix],
  );

  return (
    <div className="copy-magic__headline-assistant-trigger-button-overrides">
      <CopyMagic
        trigger={copyMagicButton}
        generatorName={CopyMagic.GENERATORS.HEADLINE_ASSISTANT}
        productEvents={productEvents}
        onApply={onApply}
      />
    </div>
  );
};

export default memo(HeadlineAssistantButton);
